import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
    selector: '[appShowPassword]',
})
export class ShowPasswordDirective implements AfterViewInit {
    private button: ElementRef;
    private icon: ElementRef;
    private textIcon: ElementRef;
    private parent: ElementRef;
    private buttonWrapper: ElementRef;
    private showingPassword = false;

    constructor(
        private elRef: ElementRef,
        private renderer: Renderer2,
    ) { }

    ngAfterViewInit(): void {
        this.createSuffixButton();
        this.renderer.listen(this.button, 'click', (event) => {
            this.toogleIcon();
            event.stopPropagation();
        });
    }

    private createSuffixButton(): void {
        this.parent = this.elRef.nativeElement.parentNode.parentNode;
        const child = this.renderer.createElement('div');
        this.renderer.addClass(child, 'mat-form-field-suffix');
        this.createButton();
        this.createButtonWrapper();
        this.createIcon();
        this.renderer.appendChild(this.button, this.buttonWrapper);
        this.renderer.appendChild(this.buttonWrapper, this.icon);
        this.renderer.appendChild(child, this.button);
        this.renderer.appendChild(this.parent, child);
    }


    private createButton(): void {
        this.button = this.renderer.createElement('button');
        this.renderer.setAttribute(this.button, 'type', 'button');
        this.renderer.setAttribute(this.button, 'mat-icon-button', '');
        this.renderer.setAttribute(this.button, 'matSuffix', '');
        this.renderer.addClass(this.button, 'mat-icon-button');
        this.renderer.addClass(this.button, 'mat-button-base');
    }

    private createIcon(): void {
        this.icon = this.renderer.createElement('mat-icon');
        this.renderer.addClass(this.icon, 'mat-icon');
        this.renderer.addClass(this.icon, 'material-icons-outlined');
        this.renderer.addClass(this.icon, 'material-icons');
        this.renderer.addClass(this.icon, 'mat-icon-no-color');
        this.createTextIcon('visibility_off');
    }

    public createTextIcon(text: string): void {
        this.textIcon = this.renderer.createText(text);
        this.renderer.appendChild(this.icon, this.textIcon);
    }

    private createButtonWrapper(): void {
        this.buttonWrapper = this.renderer.createElement('span');
        this.renderer.addClass(this.buttonWrapper, 'mat-button-wrapper');
    }

    private toogleIcon(): void {
        this.showingPassword = !this.showingPassword;
        this.renderer.removeChild(this.icon, this.textIcon);
        this.createTextIcon(this.showingPassword ? 'visibility' : 'visibility_off');
        this.elRef.nativeElement.type = this.showingPassword ? 'text' : 'password';
    }

}
